import { MOKA_INVENTORY_API } from '../constants';

export const LIBRARY_TAXES = `${MOKA_INVENTORY_API}/v2/taxes`;
export const V1_TAX_BY_ID = (id) => `${MOKA_INVENTORY_API}/v1/taxes/${id}`;
export const V1_TAX_URL = `${MOKA_INVENTORY_API}/v1/taxes`;
export const TAX_ALL_OUTLET = `${MOKA_INVENTORY_API}/v1/taxes/create_all_outlet`;
